import React from 'react'
import cls from 'classnames'
import { usePrefixCls } from './hooks/usePrefixCls'
import { Button } from '@alicloudfe/components'
export type IconProps = React.HTMLAttributes<any> & {
  ref?: React.ForwardedRef<any>
  text?: React.ReactNode
}
export type IconType = React.ForwardRefExoticComponent<IconProps>

export const Icon: IconType = React.forwardRef((originalProps, ref) => {
  const prefix = usePrefixCls('formily-icon')
  const { text, ...props } = originalProps

  if (text) {
    return (
      <Button
        text
        {...props}
        ref={ref}
        className={cls(prefix, props.className)}
      >
        {text}
      </Button>
    )
  }

  return (
    <svg
      {...props}
      ref={ref}
      className={cls(prefix, props.className)}
      style={{
        ...props.style,
        cursor: props.onClick ? 'pointer' : '',
        display: 'inline-block',
        verticalAlign: 'middle',
        fontSize: '14px',
      }}
      viewBox="64 64 896 896"
      fill="currentColor"
      width="1em"
      height="1em"
      focusable="false"
      aria-hidden="true"
    >
      {props.children}
    </svg>
  )
})

export const MenuOutlinedIcon: IconType = React.forwardRef((props, ref) => (
  <Icon {...props} ref={ref}>
    <path
      d="M262.4 192c0 35.3472 28.6528 64 64 64s64-28.6528 64-64-28.6528-64-64-64-64 28.6528-64 64zM262.4 512c0 35.3472 28.6528 64 64 64s64-28.6528 64-64-28.6528-64-64-64-64 28.6528-64 64zM633.6 192c0 35.3472 28.6528 64 64 64s64-28.6528 64-64-28.6528-64-64-64-64 28.6528-64 64zM633.6 512c0 35.3472 28.6528 64 64 64s64-28.6528 64-64-28.6528-64-64-64-64 28.6528-64 64zM262.4 832c0 35.3472 28.6528 64 64 64s64-28.6528 64-64-28.6528-64-64-64-64 28.6528-64 64zM633.6 832c0 35.3472 28.6528 64 64 64s64-28.6528 64-64-28.6528-64-64-64-64 28.6528-64 64z"
      p-id="11148"
    ></path>
  </Icon>
))

export const PlusOutlinedIcon: IconType = React.forwardRef((props, ref) => (
  <Icon {...props} ref={ref}>
    <path
      d="M832 480H544V192c0-14.08-14.08-32-32-32s-32 17.92-32 32v288H192c-14.08 0-32 14.08-32 32s17.92 32 32 32h288v288c0 14.08 14.08 32 32 32s32-17.92 32-32V544h288c14.08 0 32-14.08 32-32s-17.92-32-32-32z"
      p-id="11118"
    ></path>
  </Icon>
))

export const UpOutlinedIcon: IconType = React.forwardRef((props, ref) => (
  <Icon {...props} ref={ref}>
    <path
      d="M811.52 628.48L558.08 375.68l-22.4-22.4c-12.8-12.8-32.64-12.8-45.44 0l-275.84 275.2c-10.24 10.24-8.32 28.8 4.48 40.96 12.8 12.8 30.72 14.08 40.96 4.48l253.44-253.44 253.44 253.44c10.24 10.24 28.8 8.32 40.96-4.48 12.16-12.16 14.08-30.72 3.84-40.96z"
      p-id="11402"
    ></path>
  </Icon>
))

export const DownOutlinedIcon: IconType = React.forwardRef((props, ref) => (
  <Icon {...props} ref={ref}>
    <path
      d="M807.04 354.56c-12.8-12.8-30.72-14.08-40.96-4.48L512.64 603.52 259.84 350.08c-10.24-10.24-28.8-8.32-40.96 4.48-12.8 12.8-14.08 30.72-4.48 40.96l275.84 275.84c12.8 12.8 32.64 12.8 45.44 0l22.4-22.4 253.44-253.44c10.24-10.24 8.32-28.8-4.48-40.96z"
      p-id="11544"
    ></path>
  </Icon>
))

export const DeleteOutlinedIcon: IconType = React.forwardRef((props, ref) => (
  <Icon {...props} ref={ref}>
    <path
      d="M608 768c17.92 0 32-14.08 32-32V384c0-17.92-14.08-32-32-32s-32 14.08-32 32v352c0 17.92 14.08 32 32 32zM416 768c17.92 0 32-14.08 32-32V384c0-17.92-14.08-32-32-32s-32 14.08-32 32v352c0 17.92 14.08 32 32 32z"
      p-id="11686"
    ></path>
    <path
      d="M864 192h-128V96c0-17.92-14.08-32-32-32H320c-17.92 0-32 14.08-32 32v96H160c-17.92 0-32 14.08-32 32s14.08 32 32 32v672c0 17.92 14.08 32 32 32h640c17.92 0 32-14.08 32-32V256c17.92 0 32-14.08 32-32s-14.08-32-32-32zM352 128h320v64H352V128z m448 768H224V256h576v640z"
      p-id="11687"
    ></path>
  </Icon>
))

export const CopyOutlinedIcon: IconType = React.forwardRef((props, ref) => (
  <Icon {...props} ref={ref}>
    <path d="M928.64 252.8H768v-160c0-17.92-14.08-32-32-32H96c-17.92 0-32 14.08-32 32v672c0 17.92 14.08 32 32 32h160v128c0 17.92 14.08 32 32 32h640c17.92 0 32-14.08 32-32V284.16c0-17.28-14.08-31.36-31.36-31.36zM256 284.8v448H128v-608h576v128H288c-17.92 0-32 14.08-32 32z m640 608H320v-576h576v576z"></path>
    <path d="M608 444.8h128c14.08 0 32-14.08 32-32s-17.92-32-32-32H608c-14.08 0-32 14.08-32 32s17.92 32 32 32zM480 764.8h256c14.08 0 32-14.08 32-32s-17.92-32-32-32H480c-14.08 0-32 14.08-32 32s17.92 32 32 32zM544 604.8h192c14.08 0 32-14.08 32-32s-17.92-32-32-32H544c-14.08 0-32 14.08-32 32s17.92 32 32 32z"></path>
  </Icon>
))

export const QuestionCircleOutlinedIcon: IconType = React.forwardRef(
  (props, ref) => (
    <Icon {...props} ref={ref}>
      <path
        d="M512 64c-247.04 0-448 200.96-448 448s200.96 448 448 448 448-200.96 448-448-200.96-448-448-448z m0 832c-211.84 0-384-172.16-384-384s172.16-384 384-384 384 172.16 384 384-172.16 384-384 384z"
        p-id="11829"
      ></path>
      <path
        d="M592.64 715.52h-32.64l0.64-289.28c0-17.28-14.08-31.36-31.36-31.36h-64c-17.92 0-32 14.08-32 32s14.08 32 32 32h31.36l-0.64 256.64h-31.36c-17.92 0-32 14.08-32 32s14.08 32 32 32h128c17.92 0 32-14.08 32-32s-14.08-32-32-32zM503.04 339.2c33.92 6.4 62.72-22.4 56.32-56.32-3.84-19.2-18.56-33.92-37.76-37.76-33.92-6.4-62.72 22.4-56.32 56.32 3.84 19.2 19.2 34.56 37.76 37.76z"
        p-id="11830"
      ></path>
    </Icon>
  )
)
export const CloseCircleOutlinedIcon: IconType = React.forwardRef(
  (props, ref) => (
    <Icon {...props} ref={ref}>
      <path
        d="M512.64 64c-247.04 0-448 200.96-448 448s200.96 448 448 448 448-200.96 448-448-200.96-448-448-448z m194.56 636.8c-12.8 12.8-35.2 10.24-45.44 0L512.64 551.68l-149.12 149.12c-10.24 10.24-32.64 12.8-45.44 0s-10.24-35.2 0-45.44L467.2 506.24 329.6 368c-10.24-10.24-12.8-32.64 0-45.44s35.2-10.24 45.44 0L513.28 460.8l138.24-138.24c10.24-10.24 32.64-12.8 45.44 0s10.24 35.2 0 45.44L558.08 506.88l149.12 149.12c10.24 9.6 12.8 32.64 0 44.8z"
        p-id="11972"
      ></path>
    </Icon>
  )
)
export const CheckCircleOutlinedIcon: IconType = React.forwardRef(
  (props, ref) => (
    <Icon {...props} ref={ref}>
      <path
        d="M512 64c-247.04 0-448 200.96-448 448s200.96 448 448 448 448-200.96 448-448-200.96-448-448-448z m256 342.4l-279.68 277.76c-12.16 12.8-32.64 12.8-45.44 0.64L256.64 501.76c-12.8-12.16-12.8-32.64-0.64-45.44s32.64-12.8 45.44-0.64l163.2 160.64 257.28-254.72c12.16-12.8 32.64-12.8 45.44-0.64 12.8 12.8 12.8 32.64 0.64 45.44z"
        p-id="12114"
      ></path>
    </Icon>
  )
)
export const ExclamationCircleOutlinedIcon: IconType = React.forwardRef(
  (props, ref) => (
    <Icon {...props} ref={ref}>
      <path
        d="M512 64c-247.04 0-448 200.96-448 448s200.96 448 448 448 448-200.96 448-448-200.96-448-448-448z m-32 272c0-14.08 14.08-32 32-32s32 17.92 32 32v224c0 14.08-14.08 32-32 32s-32-17.92-32-32v-224z m22.4 383.36c-19.2-3.84-33.92-18.56-37.76-37.76-6.4-33.92 22.4-62.72 56.32-56.32 19.2 3.84 33.92 18.56 37.76 37.76 7.04 33.28-22.4 62.72-56.32 56.32z"
        p-id="12256"
      ></path>
    </Icon>
  )
)

export const EditOutlinedIcon: IconType = React.forwardRef((props, ref) => (
  <Icon {...props} ref={ref}>
    <path
      d="M952.32 218.24l-114.56-114.56c-10.24-10.24-26.88-10.24-36.48 0L710.4 192H121.6c-14.08 0-25.6 12.8-25.6 27.52V934.4c0 14.08 11.52 26.24 26.24 26.24h714.88c14.08 0 27.52-11.52 27.52-25.6V345.6l88.32-90.24c9.6-10.24 9.6-26.88-0.64-37.12zM800 896H160V256h486.4l-382.72 384c-5.12 5.12-7.68 11.52-7.68 18.56v114.56c0 14.08 17.92 26.88 32 26.88h114.56c7.04 0 13.44-2.56 18.56-7.68L800 409.6v486.4z m-409.6-160H320v-70.4l499.2-506.88L897.28 236.8 390.4 736z"
      p-id="12398"
    ></path>{' '}
  </Icon>
))
export const CloseOutlinedIcon: IconType = React.forwardRef((props, ref) => (
  <Icon {...props} ref={ref}>
    <path
      d="M557.44 512l234.24-234.24c10.24-10.24 12.8-32.64 0-45.44s-35.2-10.24-45.44 0L512 466.56 277.76 232.32c-10.24-10.24-32.64-12.8-45.44 0s-10.24 35.2 0 45.44L466.56 512l-234.24 234.24c-10.24 10.24-12.8 32.64 0 45.44s35.2 10.24 45.44 0L512 557.44l234.24 234.24c10.24 10.24 32.64 12.8 45.44 0s10.24-35.2 0-45.44L557.44 512z"
      p-id="12540"
    ></path>
  </Icon>
))
export const MessageOutlinedIcon: IconType = React.forwardRef((props, ref) => (
  <Icon {...props} ref={ref}>
    <path
      d="M933.12 128H88.96c-14.08 0-26.24 11.52-26.24 26.24V774.4c0 14.08 11.52 26.24 26.24 26.24h281.6L492.8 919.68c5.12 5.12 11.52 7.68 18.56 7.68s13.44-2.56 18.56-7.68l122.24-119.68h281.6c14.08 0 26.24-11.52 26.24-26.24V154.24c-0.64-14.72-12.8-26.24-26.88-26.24z m-37.76 608H637.44c-6.4 0-12.8 2.56-17.92 7.68L512 853.12l-108.16-109.44c-4.48-4.48-10.88-7.68-17.92-7.68H127.36V192h768v544z"
      p-id="12682"
    ></path>
    <path
      d="M342.4 511.36c33.92 6.4 62.72-22.4 56.32-56.32-3.84-19.2-18.56-33.92-37.76-37.76-33.92-6.4-62.72 22.4-56.32 56.32 3.84 18.56 19.2 33.92 37.76 37.76zM502.4 511.36c33.92 6.4 62.72-22.4 56.32-56.32-3.84-19.2-18.56-33.92-37.76-37.76-33.92-6.4-62.72 22.4-56.32 56.32 3.84 18.56 19.2 33.92 37.76 37.76zM662.4 511.36c33.92 6.4 62.72-22.4 56.32-56.32-3.84-19.2-18.56-33.92-37.76-37.76-33.92-6.4-62.72 22.4-56.32 56.32 3.84 18.56 19.2 33.92 37.76 37.76z"
      p-id="12683"
    ></path>
  </Icon>
))
